import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';

import { cn } from '@/lib/utils';

/**
 * Размеры и цвета — из макета настроек: дорожка 51×31, бегунок 27, зелёный
 * бренда во включённом состоянии и светло-серый в выключенном.
 *
 * Radix рисует переключатель обычной кнопкой, а не системным чекбоксом,
 * поэтому iOS и Android показывают его одинаково. Подавляем только подсветку
 * тапа в WebView и выделение текста — из-за них на Android при нажатии
 * появлялся серый прямоугольник.
 */
const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'peer inline-flex h-[31px] w-[51px] shrink-0 cursor-pointer select-none touch-manipulation items-center rounded-full border-2 border-transparent p-0 transition-colors [-webkit-tap-highlight-color:transparent] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-brand-green data-[state=unchecked]:bg-[#E1E4E8]',
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'pointer-events-none block h-[27px] w-[27px] rounded-full bg-white shadow-[0_2px_4px_rgba(0,0,0,0.12)] ring-0 transition-transform data-[state=checked]:translate-x-[20px] data-[state=unchecked]:translate-x-0'
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
